/** @format */

export enum FavoritesActionResult {
	REMOVED = 'REMOVED',
	REMOVAL_ERROR = 'REMOVAL_ERROR',
	OPENED_LIST_PANEL = 'OPENED_LIST_PANEL',
	OPENED_QV_PANEL = 'OPENED_QV_PANEL',
	TRIGGERED_LOGIN = 'TRIGGERED_LOGIN'
}
